import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var tooltipContent = createRuntimeFn({defaultClassName:'fx_b6b0f3e6_ru7qad3',variantClassNames:{prefersReducedMotion:{noPreference:'fx_b6b0f3e6_ru7qad4',reduce:'fx_b6b0f3e6_ru7qad5'}},defaultVariants:{prefersReducedMotion:'noPreference'},compoundVariants:[]});
var tooltipContentBackground = 'var(--fx_b6b0f3e6_ru7qad2)';

export { tooltipContent, tooltipContentBackground };
//# sourceMappingURL=content.vanilla.mjs.map
